import { CurrencyPipe, DatePipe } from "@angular/common";
import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import * as JSZip from "jszip";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { Observable, Subscription, zip } from "rxjs";
import { map } from "rxjs/operators";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { DteFilter } from "src/app/models/Dte/DteFilter";
import { FacturaExportacionFilter } from "src/app/models/Dte/Exportacion/FacturaExportacionFilter";
import { FacturaExportacion } from "src/app/models/Dte/FacturaExportacion";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { TipoDte } from "src/app/models/tipoDte";
import { Traza } from "src/app/models/Traza";
import { DteExportacionService } from "src/app/services/dte-exportacion.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PermissionService } from "src/app/services/permission.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { FormrulesConfigService } from "src/app/shared/configuration/formrules-config.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import { ConfigMantenedorDTE } from "../mantenedor-dte-emitidos/config-mantenedor-dte";
import * as FileSaver from "file-saver";
import { Response } from "../../../shared/models/Response";
import { MultipleEmailValidator } from "src/app/directives/multi-email.directive";
import { SameWordEmailValidator } from "src/app/directives/same-word-email.directive";
import { EmailData } from "src/app/shared/models/EmailData";
import { EmailAttachment } from "src/app/shared/models/EmailAttachment";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { DetalleDte } from "src/app/models/Dte/DetalleDte";
import { IDte } from "src/app/models/Dte/IDte";
import { NotaCredito } from "src/app/models/NotaCredito";
import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";
import { NotaDebito } from "src/app/models/NotaDebito";
import { ConfigMantenedorDteExportacion } from "./config-mantenedor-dte-exportacion";
import { DteExportacionCompleto } from "src/app/models/Dte/Exportacion/DteExportacionCompleto";
import { Pais } from "src/app/models/Dte/Exportacion/Pais";
import { Puerto } from "src/app/models/Dte/Exportacion/Puerto";
import { ModalidadVentas } from "src/app/models/Dte/Exportacion/ModalidadVentas";
import { TipoBulto } from "src/app/models/Dte/Exportacion/TipoBulto";
import { Bulto } from "src/app/models/Dte/Exportacion/Bulto";
import { CorreoEnvioService } from "src/app/services/CorreoEnvio.service";
import { SendInvoiceRequest } from "src/app/models/CorreoEnvio/SendInvoiceRequest";
import { ActualizarEstadoSiiRequest } from "src/app/models/Dte/ActualizarEstadoSiiRequest";
import { ReenvioEmailRequest } from "src/app/models/Dte/ReenvioEmailRequest";
import { SortType } from "@swimlane/ngx-datatable";
import { ReutilizacionMasivaRequest } from "src/app/models/Dte/ReutilzacionMasivaRequest";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { FacturadorMasivoService } from "src/app/services/facturador-masivo.service";
import { EmisorService } from "src/app/services/emisor.service";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { CodigosAduana } from "src/app/models/Dte/Exportacion/CodigosAduana";
import { VerificacionCertificadoService } from "src/app/services/verificacion-certificado.service";
import { ExportModalComponent } from "../../layout/export-modal/export-modal.component";
import * as moment from "moment";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';

@Component({
	selector: "app-mantenedor-dte-exportacion",
	templateUrl: "./mantenedor-dte-exportacion.component.html",
	styleUrls: ["./mantenedor-dte-exportacion.component.scss"],
})
export class MantenedorDteExportacionComponent implements OnInit {
	SortType = SortType;
	public tracesModal: NgbModalRef;
	public anuladorModal: NgbModalRef;
	public senderDteModal: NgbModalRef;
	public detailModal: NgbModalRef;
	loading: boolean = false;
	public configLocal = ConfigMantenedorDteExportacion;
	public rowsMantenedor: FacturaExportacion[] = [];
	public selected: FacturaExportacion[] = []; //dtes seleccionados por checkbox
	public selectedItem: FacturaExportacion; //dte seleccionado para envio individual y despliegue en modal
	public selectedAllItemsInPage: any = {}; // bool para la seleccion total de elementos en tabla
	public searchRows: any[] = [];
	public searchCriteria;
	fileIdState: Observable<object>;
	fileIdValue: string;
	registrationIdValue: string;
	receptorRutString: string;
	public configScroll: PerfectScrollbarConfigInterface = {};
	public emisorId: string;
	private sucursalId: string;
	public empresasSource;
	public tipoDteSource: TipoDte[];
	public page = new Page();
	public filter = new FacturaExportacionFilter();
	public tracesToShow: Traza[] = [];
	public dteToShow: FacturaExportacion = new FacturaExportacion();
	public completeDteToShow: DteExportacionCompleto = new DteExportacionCompleto();
	public dteToNullify: FacturaExportacion = new FacturaExportacion();
	public dteToNullifyReferences: IDte[] = [];
	public senderForm: FormGroup;
	@ViewChild("currentSwal") private currentSwal: SwalComponent;
	@ViewChild("notesSwal") private notesSwal: SwalComponent;
	public filterDescription: string;
	private paisesSource: Pais[];
	private puertoSource: Puerto[];
	private tipoBultoSource: TipoBulto[];
	public componentStarted: boolean = false;
	public usuarioId: string;
	public fechaInicioDefault: Date;
	public fechaFinDefault: Date;
	@ViewChild("tableMobile") tableRef: any;
	private closeActionsHandler: any;
	public superAdm = false;
	locale = {
		daysOfWeek: moment.weekdaysMin(),
		monthNames: moment.monthsShort(),
		firstDay: moment.localeData().firstDayOfWeek(),
		applyLabel: "ok",
		clearLabel: "Limpiar",
		format: "MM/YYYY",
	};
	
	constructor(
		public activatedRoute: ActivatedRoute,
		private dteService: DteExportacionService,
		private facturadorService: FacturadorMasivoService,
		private facturadorIndividual: FacturacionIndividualService,
		private ref: ChangeDetectorRef,
		private tokenService: TokenStorageService,
		private localStorage: LocalStorageService,
		public utilities: UtilitiesService,
		private modalService: NgbModal,
		private datePipe: DatePipe,
		private currencyPipe: CurrencyPipe,
		private formBuilder: FormBuilder,
		private formConfig: FormrulesConfigService,
		public permissions: PermissionService,
		private correoEnvioService: CorreoEnvioService,
		private router: Router,
		private emisorService: EmisorService,
		private validadorCertificadoService: VerificacionCertificadoService,
		private sessionUserService: SessionUserService
	) {
		this.superAdm = this.tokenService.getUser().superAdmin;
		this.usuarioId = (this.tokenService.getUser() as SessionUser).id;
		this.emisorId = this.tokenService.getCompany();
		this.sucursalId = this.tokenService.getSubsidiary();

		this.facturadorIndividual.getCodigosAduana().subscribe((res) => {
			let codigos: CodigosAduana = res.data;
			this.localStorage.saveCodigosAduana(codigos);

			this.paisesSource = this.localStorage.getPaises();
			this.puertoSource = this.localStorage.getPuertos();
			this.tipoBultoSource = this.localStorage.getTipoBultos();
		});

		//this.filter.importacionMasivaId = "";
		this.empresasSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		this.tipoDteSource = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
		if (this.superAdm) {
			this.getEmisoresFullList();
		}
		this.checkStateId();
		this.starterPage();
		this.filter.emisorId = this.emisorId;
		this.filter.sucursalId = this.sucursalId;
		if (this.fileIdState) {
			this.getFileIdInState();
		}
		this.filter.reutilizado = 0;
		//this.filter.tipoDteId = "";
		this.createSenderForm();
	}
	checkStateId() {
		this.fileIdState = this.activatedRoute.paramMap.pipe(map(() => window.history.state));
	}
	getFileIdInState() {
		this.loading = true;
		this.fileIdState
			.subscribe((result) => {
				this.fileIdValue = result["paramId"];
				this.registrationIdValue = result["registrationId"];
				this.receptorRutString = result["receptorRut"];
				this.filterDescription = result["filterDescription"];
				this.filter.importacionMasivaId = this.fileIdValue ? this.fileIdValue : ""; //the parameter for File filtering is added once that obtained from the window state.
				this.filter.razonSocial = result["receptorNombre"] ? result["receptorNombre"] : "";
				let emisorImportado = result["filterEmisor"];
				this.filter.emisorId = emisorImportado ? emisorImportado : this.emisorId;
				let sucursalImportado = result["filterSucursal"];
				this.filter.sucursalId = sucursalImportado ? sucursalImportado : this.sucursalId;
				let fechaDesde = result["fechaDesde"];
				let fechaHasta = result["fechaHasta"];
				if (fechaDesde && fechaHasta) {
					this.filter.fechaDesde = fechaDesde;
					this.filter.fechaHasta = fechaHasta;
					this.syncSearchDateRangeFromFilter();
				}
				this.loading = false;
			})
			.add(() => {
				this.loading = false;
			});
	}

	private syncSearchDateRangeFromFilter() {
		const fechaInicio = moment(this.filter.fechaDesde);
		const fechaFin = moment(this.filter.fechaHasta);
		if (!fechaInicio.isValid() || !fechaFin.isValid()) {
			return;
		}
		this.fechaInicioDefault = fechaInicio.toDate();
		this.fechaFinDefault = fechaFin.toDate();
	}

	toggleActions(row: any): void {
		const newState = !row.showActions;
		this.rowsMantenedor.forEach(r => {
		  if (r !== row && r.showActions) {
			r.showActions = false;
			document.removeEventListener('click', this.closeActionsHandler);
		  }
		});
	  
		row.showActions = newState;
	  
		if (newState) {
		  this.closeActionsHandler = this.closeActionsMenu.bind(this, row);
		  setTimeout(() => document.addEventListener('click', this.closeActionsHandler), 0);
		} else {
		  document.removeEventListener('click', this.closeActionsHandler);
		}
	  }
	  
	closeActionsMenu(row: any, event: MouseEvent): void {
		if (!(event.target as HTMLElement).closest('.action-container')) {
			row.showActions = false;
			this.ref.detectChanges();
			document.removeEventListener('click', this.closeActionsHandler);
		}
	}

	public getTotalPages(rowCount: number, pageSize: number): number {
		if (!pageSize) { 
		  return 1; 
		}
		return Math.ceil(rowCount / pageSize);
	  }

	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.validarCertificado();
	}

	private async validarCertificado() {
		const validacionCertificado = await this.validadorCertificadoService.validar();
		if (validacionCertificado) {
			this.setPage({ offset: 0 });
		}
	}

	ngAfterViewInit() {}

	downloadFile() {}
	detailOpenModal(modalRef, row: FacturaExportacion) {
		this.dteToShow = row;
		this.loading = true;
		this.dteService
			.getCompleteDetails(row.dteId)
			.subscribe(
				(res) => {
					this.completeDteToShow = res.data;
					this.setNombresExportacion(this.completeDteToShow);
					this.setPaisToElement(this.completeDteToShow);
					this.setNombreBultos(this.completeDteToShow.bultos);
					//set names for showing
					this.completeDteToShow.descuentoGlobal = res.data.descuentoRecargos != null && res.data.descuentoRecargos.length > 0 ? res.data.descuentoRecargos[0].valor : undefined;
				},
				(err) => {
					this.setSwalAndFire(this.currentSwal, "error", "Error al obtener detalles", "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error));
				}
			)
			.add(() => {
				this.loading = false;
				this.ref.detectChanges();
				this.detailModal = this.modalService.open(modalRef, {
					windowClass: "",
					size: "lg",
					centered: true,
				});
			});
	}

	searchElements(emisorId: string) {
		this.loading = true;
		this.dteService.getDataByPage(this.filter, this.page).subscribe(
			(result) => {
				let elements = result.data as FacturaExportacion[];
				elements.forEach((row) => {
					this.setEmisorToElement(row);
				});
				this.rowsMantenedor = [...elements];
			},
			(error) => {
				this.setSwalAndFire(this.currentSwal, "error", "Error al obtener elementos", "No fue posible obtener los elementos, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(error.error));
			},
			() => {
				this.loading = false;
				this.ref.detectChanges();
			}
		);
	}

	ngOnDestroy() {
		this.fileIdState = undefined;
	}

	changeSearchedRows(data) {
		if (data != null) {
			this.rowsMantenedor = data;
		}
	}

	onSelect({ selected }) {
		this.selected.splice(0, this.selected.length);
		this.selected.push(...selected);
	}

	getId(row) {
		return row.dteId;
	}

	selectAll(event) {
		if (!this.selectedAllItemsInPage[this.page.pageNumber]) {
			if (this.selected.length > 0) {
				this.rowsMantenedor.map((dte) => {
					this.selected = this.selected.filter((selectedDte) => selectedDte.dteId !== dte.dteId);
				});
			}
			this.selected.push(...this.rowsMantenedor);
			this.selected = [...this.selected];
			this.selectedAllItemsInPage[this.page.pageNumber] = true;
		} else {
			this.rowsMantenedor.map((dte) => {
				this.selected = this.selected.filter((selectedDte) => selectedDte.dteId !== dte.dteId);
			});
			this.selectedAllItemsInPage[this.page.pageNumber] = false;
		}
	}

	setEmisorToElement(row: IDte) {
		let empresaAsociada = this.empresasSource.find((Emisor) => Emisor.emisorId == row.emisorId);
		row.emisorAsociado = empresaAsociada;
	}

	starterPage() {
		this.page.pageNumber = 0;
		this.page.pageSize = 10;
		this.selectedAllItemsInPage[this.page.pageNumber] = false;
	}
	setPageSize() {
		//this.page.currentPageSize = this.page.page
		this.setPage({ offset: 0 });
	}
	searchElementsByFilter(event) {
		//se toman los valores del filtro que necesite el endpoint de filtro para dte
		this.filter = this.filterConcordance(this.configLocal.barraBusqueda.criteriosKeys, this.filter, event);
		//this.filter.tipoDteId = event.tipoDteId != null ? event.tipoDteId : "";
		this.filter.fechaDesde = event.fechaInicio;
		this.filter.fechaHasta = event.fechaFin;
		this.filter.puerto = event.puerto ? event.puerto : "";
		this.filter.pais = event.pais ? event.pais : "";
		this.filter.clausula = event.clausulaVenta ? event.clausulaVenta : "";
		this.filter.tipoDteId = event.tipoDteId != null ? event.tipoDteId : "";
		this.filter.reutilizado = event.reutilizado ? 1 : 0;
		this.filter.modalidad = event.modalidadVenta ? event.modalidadVenta : "";
		this.filter[event.criterio] = event.busqueda;
		this.filter = this.utilities.clearOtherFilterCriterias(event.criterio, this.filter, this.configLocal);
		this.filter.estadoSii = event.estadoDte;
		this.filter.emisorId = event.emisorId ? event.emisorId : this.emisorId;
		this.filter.sucursalId = event.sucursalId ? event.sucursalId : this.sucursalId;
		this.setPage({ offset: 0 });
	}

	filterConcordance(configCriterias, dteFilter: FacturaExportacionFilter, eventFilter): FacturaExportacionFilter {
		//vaciar del dteFilter aquellos campos distinto al presnetado en el eventFilter actual, segun el arreglo configCriterias
		configCriterias.forEach((criteria) => {
			if (criteria != eventFilter.criterio) {
				dteFilter[criteria] = "";
			}
		});
		return dteFilter;
	}

	setPage(pageInfo) {
		this.loading = true;
		this.page.pageNumber = pageInfo.offset;
		let localPage = JSON.parse(JSON.stringify(this.page));
		localPage.pageNumber += 1;

		//llamada generica a los dte paginados
		this.dteService
			.getDataByPage(this.filter, localPage)
			.subscribe(
				(pagedData) => {
					let elements = pagedData.data as FacturaExportacion[];
					this.ref.detectChanges();
					elements.forEach((row) => {
						this.setEmisorToElement(row);
						this.setTipoDteToElement(row);
					});
					this.rowsMantenedor = [...elements];
					this.ref.detectChanges();
					this.setPagefromResponse(this.page, pagedData);
				},
				(error) => {
					this.currentSwal.icon = "error";
					this.currentSwal.title = "Error en la solicitud";
					this.currentSwal.text = this.utilities.setErrorMessageFromArray(error.error);
					this.currentSwal.fire();
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			)
			.add(() => {
				this.loading = false;
				this.componentStarted = true;
				this.ref.detectChanges();
			});
	}

	setPagefromResponse(currentPage: Page, data: PagedResponse<FacturaExportacion>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	downloadXml(dte: FacturaExportacion) {
		this.dteService.getXml(dte.dteId).subscribe(
			(result) => {
				this.loading = true;
				let b64Response = result.data.xml;
				const blobXml = this.utilities.convertB64ToBlob(b64Response, "text/xml");
				FileSaver.saveAs(blobXml, dte.folio + "_" + "dte.xml");
				this.loading = false;
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error en XML";
				this.currentSwal.text = "No fue posible obtener el documento." + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
			},
			() => {
				this.loading = false;
			}
		);
	}

	downloadPDF(dte: FacturaExportacion) {
		this.loading = true;
		this.dteService.getPdf(dte.dteId).subscribe(
			(result) => {
				this.responseToPdfDownload(result.data, dte);
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error al descargar pdf";
				this.currentSwal.text = "No se pudo generar el documento, intente mas tarde." + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
			}
		);
	}

	multipleDocumentDownload(fileType) {
		if (this.selected.length > 0) {
			this.loading = true;
			let dteIds = this.selected.map(dte => dte.dteId);
			this.getDownloadFilesObservable(dteIds, fileType).subscribe(
                (response) => {
                    const blob = new Blob([response], { type: 'application/zip' });
                    const dateOfDownLoad = this.datePipe.transform(Date.now(), 'dd/MM/yyyy');
                    FileSaver.saveAs(blob, `documentos_${dateOfDownLoad}_${fileType}.zip`);

                    this.currentSwal.icon = "success";
                    this.currentSwal.title = "Descarga de documentos";
                    this.currentSwal.text = "Los documentos seleccionados se han descargado";
                    this.currentSwal.fire();
                },
                (err) => {
					this.loading = false;
					this.ref.detectChanges();
					console.log(err);
                    this.currentSwal.icon = "error";
                    this.currentSwal.title = "Error en exportación";
                    this.currentSwal.text = "No ha sido posible descargar los documentos seleccionados.\nFavor intentar más tarde o contactar a su administrador.";
                    if (err.error.errors) {
                        this.currentSwal.text += this.utilities.setErrorMessageFromArray(err.error);
                    }
                    this.currentSwal.fire();					
                },
                () => {
                    this.loading = false;
					this.ref.detectChanges();
                }
            );
		}
		else {
			Swal.fire({
				icon: "error",
				title: "Error de Selección",
				text: "No se ha seleccionado ningún documento para envío.\nFavor seleccionar un documento con la columna selectora.",
			});
		}
	}

	getDownloadFilesObservable(Ids: string[], type: string): Observable<any> {
		const downloadRequest = {
            dteIds: Ids,
            fileType: type
        };
		return this.dteService.getZip(downloadRequest);
	}

	getDocumentSubscription(dteId: string, docType: string): Subscription {
		switch (docType) {
			case "pdf":
				return this.dteService.getPdf(dteId).subscribe();
				break;
			case "pdf":
				break;
			case "both":
				break;
			default:
				break;
		}
	}
	getDownloadXmlObservable(id: string): Observable<Response<any>> {
		return this.dteService.getXml(id);
	}
	getDownloadPdfObservable(id: string): Observable<Response<any>> {
		return this.dteService.getPdf(id);
	}

	responseToPdfDownload(responseB64, currentDte: FacturaExportacion) {
		const pdfBlob = this.utilities.convertB64ToBlob(responseB64, "application/pdf");
		FileSaver.saveAs(pdfBlob, currentDte.folio + "_dte.pdf");
		this.loading = false;
		this.ref.detectChanges();
	}
	convertStreamToFileDownload(responseB64, currentDte: FacturaExportacion, fileType: string, extensionFile: string) {
		const docBlob = this.utilities.convertB64ToBlob(responseB64, fileType);
		FileSaver.saveAs(docBlob, currentDte.folio + "_" + currentDte.razonSocial + "_dte." + extensionFile);
	}

	openDocumentSenderModal(modalRef, row?: FacturaExportacion) {
		if (row) {
			this.selectedItem = row;
		} else if (this.selected.length > 0) {
			this.selectedItem = undefined;
		} else {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error de Selección";
			this.currentSwal.text = "No se ha seleccionado ningún documento para envío.\nFavor seleccionar un documento con la columna selectora o usar la emisión individual desde el icono de 'Enviar Correo'";
			this.currentSwal.fire();
			return;
		}

		this.senderDteModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});

		this.senderDteModal.closed.subscribe((res) => {
			this.senderForm.reset();
		});
		this.senderDteModal.dismissed.subscribe((res) => {
			this.senderForm.reset();
		});
	}

	createSenderForm() {
		this.senderForm = this.formBuilder.group(
			{
				receiverEmail: [
					"",
					[
						Validators.required,
						//Validators.pattern(this.formConfig.emailPatternRegex),
						MultipleEmailValidator,
						Validators.maxLength(320),
					],
				],
				ccEmail: [
					"",
					[
						//Validators.pattern(this.formConfig.emailPatternRegex),
						MultipleEmailValidator,
						Validators.maxLength(320),
					],
				],
				ccoEmail: [
					"",
					[
						//Validators.email,
						//Validators.pattern(this.formConfig.emailPatternRegex),
						MultipleEmailValidator,
						Validators.maxLength(320),
					],
				],
				sendPdfCheckbox: [true],
				sendXmlCheckbox: [true],
				comments: [""]
			},
			{ validators: SameWordEmailValidator }
		);
	}

	onSubmitSenderForm() {
		if (this.senderForm.valid) {
			let emailReceivers: string[] = this.senderForm.controls.receiverEmail.value.toString().split(",");
			let emailsCCs: string[] = this.senderForm.controls.ccEmail.value ? this.senderForm.controls.ccEmail.value.toString().split(",") : [];
			let emailCCOs: string[] = this.senderForm.controls.ccoEmail.value ? this.senderForm.controls.ccoEmail.value.toString().split(",") : [];
			var mailRequest = new SendInvoiceRequest();
			mailRequest.ccos = emailCCOs;
			mailRequest.ccs = emailsCCs;
			mailRequest.dteId = this.selectedItem.dteId;
			mailRequest.dteType = this.selectedItem.codigoTipoDte;
			mailRequest.to = emailReceivers;
			mailRequest.emailType = 3;
			mailRequest.pdf = this.senderForm.controls.sendPdfCheckbox.value ? true : false;
			mailRequest.xml = this.senderForm.controls.sendXmlCheckbox.value ? true : false;
			mailRequest.comments = this.senderForm.controls.comments.value;
			if (mailRequest.pdf || mailRequest.xml) {
				if (!this.selectedItem && this.selected.length == 1) {
					this.sendDteDocuments(mailRequest);
				} else if (this.selectedItem) {
					this.sendDteDocuments(mailRequest);
				} else if (this.selected.length != 1) {
					//opcion temporal para solicitar solo un elemento
					this.currentSwal.icon = "error";
					this.currentSwal.title = "Error de Selección";
					this.currentSwal.text = "Solo puede seleccionar un elemento para el envío.\nFavor seleccionar un documento con la columna selectora o usar la emisión individual desde el icono de 'Enviar Correo'";
					this.currentSwal.fire();
					return;
				}
			} else {
				Swal.fire({
					title: "Documentos No Seleccionados",
					text: "Favor indicar por lo menos un documento a enviar",
					icon: "info",
				});
				return;
			}
		}
	}

	onSubmitEmail() {
		// email request to backend handling
		//valid form data
		if (this.senderForm.valid) {
			//get dtes id array
			let dteIdList: Array<string> = [];
			if (this.selectedItem) {
				dteIdList.push(this.selectedItem.dteId);
			} else if (this.selected.length > 0) {
				this.selected.forEach((dte) => {
					dteIdList.push(dte.dteId);
				});
			}
			//attach xml pdf or both seing boolean in request
			let sendingPdf: boolean = this.senderForm.controls.sendPdfCheckbox.value;
			let sendingXml: boolean = this.senderForm.controls.sendXmlCheckbox.value;
			//attach array of email addresses
			let arrayReceiversEmails: string[] = this.senderForm.controls.receiverEmail.value.toString().split(",");
			let arrayCopyEmails: string[] = this.senderForm.controls.ccEmail.value.toString().split(",");
			let arrayBlindCopyEmails: string[] = this.senderForm.controls.ccoEmail.value.toString().split(",");
		}
	}

	sendDteDocuments(request: SendInvoiceRequest) {
		this.loading = true;
		this.ref.detectChanges();
		this.correoEnvioService.sendEmail(request).subscribe(
			(result) => {
				let resumenEnvioCorreo: string = "";
				resumenEnvioCorreo = "Se envió el documento a las siguientes direcciones:<br>" + request.to + "<br>";
				if (request.ccs[0] != "") {
					if (request.ccs.length > 0) {
						resumenEnvioCorreo += "<br> Con copia a las siguientes direcciones:<br>" + request.ccs + "<br>";
					}
				}
				if (request.ccos[0] != "") {
					if (request.ccos.length > 0) {
						resumenEnvioCorreo += "<br> Con copia oculta para las siguientes direcciones:<br>" + request.ccos;
					}
				}
				Swal.fire({
					icon: "success",
					title: "Envío exitoso",
					showCloseButton: true,
					html: "<div style='text-align:center;'><p>" + resumenEnvioCorreo + "</p></div>",
				});
				this.senderDteModal.close();
				this.senderForm.reset();
				this.senderForm.controls.ccEmail.patchValue("");
				this.senderForm.controls.ccoEmail.patchValue("");
				this.senderForm.controls.receiverEmail.patchValue("");
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error en el envío";
				this.currentSwal.text = "No fue posible enviar el documento." + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
			},
			() => {
				this.loading = false;
				this.ref.detectChanges();
			}
		);
	}

	async getPdfForEmailRequest(dteId: string, pdfStringRef: string) {
		pdfStringRef = await (await this.dteService.getPdf(dteId).toPromise()).data;
		return pdfStringRef;
	}

	getXml(dte: FacturaExportacion) {
		this.dteService.getXml(dte.dteId).subscribe(
			(result) => {
				this.loading = true;
				let b64Response = result.data.xml;
				const blobXml = this.utilities.convertB64ToBlob(b64Response, "text/xml");
				let blob = new Blob([blobXml], { type: "text/xml" });
				let fileURL = URL.createObjectURL(blobXml);
				this.popupCenter(fileURL, "Documentos Tributario Electrónico", 600, 800);
				this.loading = false;
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error en XML";
				this.currentSwal.text = "No fue posible obtener el documento." + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
			},
			() => {
				this.loading = false;
			}
		);
	}

	popupCenter(url, title, w, h) {
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

		const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft;
		const top = (height - h) / 2 / systemZoom + dualScreenTop;
		const newWindow = window.open(
			url,
			title,
			`
    scrollbars=yes,
    width=${w / systemZoom}, 
    height=${h / systemZoom}, 
    top=${top}, 
    left=${left}
    `
		);
		if (window.focus) {
			newWindow.focus();
		}
	}

	//trazabilidad
	openTraceShowModal(modalRef, dte: FacturaExportacion) {
		this.dteToShow = dte;
		this.loading = true;
		this.dteService
			.getTrace(this.dteToShow.dteId)
			.subscribe(
				(result) => {
					this.tracesToShow = result.data as Traza[];
					this.loading = false;
					this.ref.detectChanges();
				},
				(error) => {
					this.loading = false;
					this.currentSwal.icon = "error";
					this.currentSwal.title = "Error en Trazabilidad";
					this.currentSwal.text = "No es posible obtener la trazabilidad de este documento. Intente mas tarde. ";
					this.currentSwal.text += this.utilities.setErrorMessageFromArray(error.error);
					this.currentSwal.fire();
				},
				() => {
					this.loading = false;
				}
			)
			.add(() => {
				this.loading = false;
				this.tracesModal = this.modalService.open(modalRef, {
					windowClass: "",
					size: "lg",
					centered: true,
				});
			});
	}
	get mostrarMsgSii(): boolean {
		const estado = this.dteToShow?.estadoSii;
		const hayCorreo = this.tracesToShow?.some(
			t => t.descripcion?.toLowerCase().includes('validación desde correo')
		);
		return (estado === 5 || estado === 7) && !hayCorreo;
	}


	openAnularDteModal(modalRef, dte: FacturaExportacion) {
		this.dteToNullify = dte;
		this.loading = true;
		this.dteService
			//.getDetalleDteExportacion(dte.dteId)
			.getCompleteDetails(dte.dteId)
			.subscribe(
				(result) => {
					this.ref.detectChanges();
					let completo = result.data as DteExportacionCompleto;
					this.dteToNullify.detalleDte = completo.detalledtes;
					this.dteToNullify.clienteInternacionalAsociado = completo.clienteInternacional;
					this.dteToNullifyReferences = undefined;
					this.dteToNullify.notaCreditoHabilitada = true;
					(this.dteToNullify.notaDebitoHabilitada = true), (this.loading = false);
					this.ref.detectChanges();
					this.anuladorModal = this.modalService.open(modalRef, {
						windowClass: "",
						size: "lg",
					});
				},
				(error) => {
					this.loading = false;
					this.notesSwal.icon = "error";
					this.notesSwal.title = "Error en anulación";
					this.notesSwal.text = "No es posible obtener los detalles del documento a anular." + this.utilities.setErrorMessageFromArray(error.error);
					this.notesSwal.fire();
				},
				() => {}
			)
			.add(() => {
				this.loading = false;
			});
	}

	closeAnularDteModal() {
		this.anuladorModal.close();
	}

	getTraza(dte: DteEmitido) {}



	commaSepEmail = (control: AbstractControl): { [key: string]: any } | null => {
		const emails = control.value.split(",").map((e) => e.trim());
		const forbidden = emails.some((email) => this.formConfig.emailPatternRegex.test(email));
		return forbidden ? { toAddress: { value: control.value } } : null;
	};

	newCreditNote(data: NotaCredito) {
		let notaCreditoDte = new FacturaExportacion();
		notaCreditoDte.nombreTipoDte = "Nota de Crédito Electrónica";
		notaCreditoDte.folio = 1000;
		notaCreditoDte.emisorAsociado = data.dteReferencia.emisorAsociado;
		notaCreditoDte.rutReceptorDv = data.dteReferencia.rutReceptorDv;
		notaCreditoDte.razonSocial = data.dteReferencia.razonSocial;
		notaCreditoDte.fecha = new Date();
		if (data.tipoNota == 0) {
			notaCreditoDte.total = data.dteReferencia.total;
		} else if (data.tipoNota == 2) {
			notaCreditoDte.total = 0;
		} else {
			notaCreditoDte.total = data.total;
		}
		this.loading = true;
		this.dteService.creditNoteDteExportNullification(data).subscribe(
			(result) => {
				let dteResult = result.data as FacturaExportacion;
				notaCreditoDte.dteId = dteResult.dteId;
				notaCreditoDte.folio = dteResult.folio;
				notaCreditoDte.estadoSii = dteResult.estadoSii;
				notaCreditoDte.nombreTipoDte = "NC.EX.E";
				notaCreditoDte.codigoTipoDte = 112;
				notaCreditoDte.anulado = false;
				notaCreditoDte.notaCreditoHabilitada = false;
				notaCreditoDte.notaDebitoHabilitada = true;
				//this.setTipoDteToElement(notaCreditoDte);
				// this.rowsMantenedor.unshift(notaCreditoDte);
				// this.rowsMantenedor = [...this.rowsMantenedor];
				this.loading = false;
				this.ref.detectChanges();
				this.setPage({ offset: 0 });
				this.notesSwal.icon = "success";
				this.notesSwal.title = "Documento Generado";
				this.notesSwal.text = "Se ha generado el documento correctamente";
				this.notesSwal.fire();
				if (data.tipoNota == 0) {
					this.updateConditionOfDte(data.dteReferenciaId, "anulado", true);
				}
				this.anuladorModal.close();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.notesSwal.icon = "error";
				this.notesSwal.title = "Error en anulación";
				this.notesSwal.text = "Ha ocurrido un error al intentar generar el documento.\n";
				if (error.error.errors) {
					error.error.errors.forEach((errorMsg) => {
						this.notesSwal.text += "\n" + errorMsg + "\n";
					});
				}
				this.notesSwal.fire();
			},
			() => {
				this.loading = false;
				this.ref.detectChanges();
			}
		);
	}
	newDebitNoteNullification(data: NotaDebito) {
		let dte = new FacturaExportacion();
		dte.nombreTipoDte = "Nota de Crédito Electrónica";
		dte.folio = 1000;
		dte.emisorAsociado = data.dteReferencia.emisorAsociado;
		dte.rutReceptorDv = data.dteReferencia.rutReceptorDv;
		dte.razonSocial = data.dteReferencia.razonSocial;
		dte.fecha = new Date();
		if (data.tipoNota == 0) {
			dte.total = data.dteReferencia.total;
		} else if (data.tipoNota == 2) {
			dte.total = 0;
		} else {
			dte.total = data.total;
		}
		this.loading = true;
		this.dteService.debitNoteDteExportNullification(data).subscribe(
			(result) => {
				let dteResult = result.data as FacturaExportacion;
				dte.dteId = dteResult.dteId;
				dte.folio = dteResult.folio;
				dte.estadoSii = dteResult.estadoSii;
				dte.nombreTipoDte = "ND.EX.E";
				dte.codigoTipoDte = 111;
				dte.anulado = false;
				dte.notaCreditoHabilitada = false;
				dte.notaDebitoHabilitada = false;
				//this.setTipoDteToElement(dte);
				// this.rowsMantenedor.unshift(dte);
				// this.rowsMantenedor = [...this.rowsMantenedor];
				this.setPage({ offset: 0 });
				this.loading = false;
				this.ref.detectChanges();
				this.notesSwal.icon = "success";
				this.notesSwal.title = "Documento Generado";
				this.notesSwal.text = "Se ha generado el documento correctamente";
				this.notesSwal.fire();
				if (data.tipoNota == 0) {
					this.updateConditionOfDte(data.dteReferenciaId, "anulado", true);
				}
				this.anuladorModal.close();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.notesSwal.icon = "error";
				this.notesSwal.title = "Error en anulación";
				this.notesSwal.text = "Ha ocurrido un error al intentar generar el documento.\n";
				if (error.error.errors) {
					error.error.errors.forEach((errorMsg) => {
						this.notesSwal.text += "\n" + errorMsg + "\n";
					});
				}
				this.notesSwal.fire();
			}
		);
	}
	newDebitNoteInterest(data: NotaDebito) {
		let dte = new FacturaExportacion();
		dte.nombreTipoDte = "Nota de Crédito Electrónica";
		dte.folio = 1000;
		dte.emisorAsociado = data.dteReferencia.emisorAsociado;
		dte.rutReceptorDv = data.dteReferencia.rutReceptorDv;
		dte.razonSocial = data.dteReferencia.razonSocial;
		dte.fecha = new Date();
		if (data.tipoNota == 0) {
			dte.total = data.dteReferencia.total;
		} else if (data.tipoNota == 2) {
			dte.total = 0;
		} else {
			dte.total = data.total;
		}
		this.loading = true;
		this.dteService.debitNoteNullificationInterests(data).subscribe(
			(result) => {
				let dteResult = result.data as FacturaExportacion;
				dte.dteId = dteResult.dteId;
				dte.folio = dteResult.folio;
				dte.estadoSii = dteResult.estadoSii;
				dte.nombreTipoDte = "N.D.E";
				dte.codigoTipoDte = 56;
				dte.anulado = false;
				dte.notaCreditoHabilitada = false;
				dte.notaDebitoHabilitada = false;
				//this.setTipoDteToElement(dte);
				// this.rowsMantenedor.unshift(dte);
				// this.rowsMantenedor = [...this.rowsMantenedor];
				this.loading = false;
				this.ref.detectChanges();
				this.setPage({ offset: 0 });
				this.notesSwal.icon = "success";
				this.notesSwal.title = "Documento Generado";
				this.notesSwal.text = "Se ha generado el documento correctamente";
				this.notesSwal.fire();
				if (data.tipoNota == 0) {
					this.updateConditionOfDte(data.dteReferenciaId, "anulado", true);
				}
				this.anuladorModal.close();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.notesSwal.icon = "error";
				this.notesSwal.title = "Error en anulación";
				this.notesSwal.text = "Ha ocurrido un error al intentar generar el documento.\n";
				if (error.error.errors) {
					error.error.errors.forEach((errorMsg) => {
						this.notesSwal.text += "\n" + errorMsg + "\n";
					});
				}
				this.notesSwal.fire();
			}
		);
	}

	getCellClass({ row, column, value }): any {
		return row.codigoTipoDte === 61 ? "is-monto-nota-credito number-table-alignment" : "number-table-alignment";
	}

	updateConditionOfDte(dteId: string, dteProperty: string, propertyValue: any) {
		let currentDte = this.rowsMantenedor.find((dte) => dte.dteId == dteId);
		if (currentDte) {
			currentDte[dteProperty] = propertyValue;
		}
	}

	setSwalAndFire(swalReference: SwalComponent, iconString: SweetAlertIcon, titleString: string, textString: string) {
		swalReference.icon = iconString;
		swalReference.title = titleString;
		swalReference.text = textString;
		swalReference.fire();
	}

	navigateToFacturador(type: InvoiceType) {
		if (!(this.permissions.canIssueInvoice(type))) { return; }
		this.router.navigateByUrl("facturador-individual", {
			state: { invoiceType: type },
		});
	}

	setTipoDteToElement(row: FacturaExportacion) {
		let tipoDteAsociado = this.tipoDteSource.find((tipo) => tipo.codigosii == row.codigoTipoDte);
		row.nombreTipoDte = tipoDteAsociado.abreviacion;
	}

	setPaisToElement(row: DteExportacionCompleto) {
		let paisCliente = this.paisesSource.find((pais) => pais.codigoSii == row.clienteInternacional.codigoPais);
		let paisDestino = this.paisesSource.find((pais) => pais.codigoSii == row.dteExportacion.codigoPaisDestino);
		row.clienteInternacional.nombrePais = paisCliente.nombre;
		row.dteExportacion.nombrePaisDestino = paisDestino.nombre;
	}
	setNombresExportacion(row: DteExportacionCompleto) {
		let puertoDesembarque = this.puertoSource.find((puerto) => puerto.puertoId == row.dteExportacion.puertoDesembarqueId);
		let puertoEmbarque = this.puertoSource.find((puerto) => puerto.puertoId == row.dteExportacion.puertoEmbarqueId);
		let territorioDestino;
		row.dteExportacion.nombrePuertoDestino = puertoDesembarque.nombrePuerto;
		row.dteExportacion.nombrePuertoEmbarque = puertoEmbarque.nombrePuerto;
	}

	setNombreBultos(bultos: Bulto[]) {
		bultos.forEach((bulto) => {
			let tipo = this.tipoBultoSource.find((tipo) => tipo.tipoBultoId == bulto.tipoBultoId);
			bulto.nombreTipoBulto = tipo.descripcion;
		});
	}

	resendDte(dte: FacturaExportacion) {
		this.loading = true;
		var request = new ActualizarEstadoSiiRequest();
		request.Dtes = [dte.dteId];
		request.usuarioId = this.tokenService.getUser().id;
		request.emisorId = this.emisorId;
		this.dteService.resendDte(request).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Estado Sii Actualizado",
					text: "El documento volverá a ser enviado al servicio de impuestos internos",
				});
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Actualizar Estado Sii",
					text: "No fue posible actualizar el estado sii del documento. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	toggleExpandRow(row) {
		this.tableRef.rowDetail.toggleExpandRow(row);
	}

	resendEmailSii(dte: FacturaExportacion) {
		this.loading = true;
		var request = new ReenvioEmailRequest();
		request.dteId = dte.dteId;
		request.usuarioId = this.tokenService.getUser().id;
		request.emisorId = this.emisorId;
		this.dteService.resendEmailSii(request).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Reenvio de Email Validación Sii",
					text: "La validación del documento desde el sii fue reenviada al email registrado en el servicio de impuestos internos",
				});
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al solicitar reenvio de correo de validación",
					text: "No fue posible solicitar el reenvio del correo de validación desde el sii. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}
	reuse(dte: FacturaExportacion) {
		this.loading = true;
		this.dteService.reuse(dte.dteId).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Reutilización de Folio",
					text: res.message,
				});
				this.setPage({ offset: 0 });
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Solicitar Reutilización de Folio",
					text: "No fue posible solicitar la reutilización de folio. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	tryMassiveRouseConfirm() {
		if (this.selected.length > 0) {
			var valid = false;
			var ids: string[] = [];
			var invalidList = this.selected.filter((x) => x.estadoSii == 6 || x.estadoSii == 7);
			if (invalidList.length > 0) {
				Swal.fire({
					icon: "error",
					title: "Error de Selección",
					text: "Solo se pueden reutilizar folios de documentos que no estén aceptados por el sii",
				});
				return;
			}
			Swal.fire({
				icon: "info",
				title: "Reutilizar folios",
				text: "¿Está seguro de reutilizar los folios de los documentos seleccionados?",
				confirmButtonText: "Continuar",
				confirmButtonColor: "#1BC5BD",
				showCancelButton: true,
				cancelButtonText: "Cancelar",
				cancelButtonColor: "#F64E60",
			}).then((res) => {
				if (res.isConfirmed) {
					this.massiveReuse();
				} else {
					return;
				}
			});
		} else {
			Swal.fire({
				icon: "error",
				title: "Error de Selección",
				text: "No se ha seleccionado ningún documento válido para reutilizar.\nFavor seleccionar un documento con la columna selectora.",
			});
		}
	}
	massiveReuse() {
		if (this.selected.length > 0) {
			var valid = false;
			var ids: string[] = [];
			var invalidList = this.selected.filter((x) => x.estadoSii == 6 || x.estadoSii == 7);
			if (invalidList.length > 0) {
				Swal.fire({
					icon: "error",
					title: "Error de Selección",
					text: "Solo se pueden reutilizar folios de documentos que no estén aceptados por el sii",
				});
			} else {
				this.selected.forEach((dte) => {
					ids.push(dte.dteId);
				});
				this.loading = true;
				var request = new ReutilizacionMasivaRequest();
				request.ids = ids;
				request.usuarioId = this.usuarioId;
				this.dteService.massivereuse(request).subscribe(
					(res) => {
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "success",
							title: "Reutilización de Folios Masivo",
							text: res.message,
						});
						this.setPage({ offset: 0 });
						this.selected = [];
					},
					(error) => {
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "error",
							title: "Error al Solicitar Reutilización de Folios Masivo",
							text: "No fue posible solicitar la reutilización de folios masivo. " + this.utilities.setErrorMessageFromArray(error.error),
						});
					}
				);
			}
		} else {
			Swal.fire({
				icon: "error",
				title: "Error de Selección",
				text: "No se ha seleccionado ningún documento válido para reutilizar.\nFavor seleccionar un documento con la columna selectora.",
			});
		}
	}

	downloadMassiveFile(dte: FacturaExportacion) {
		var valid = dte.importacionMasivaId ? true : false;
		if (valid) {
			this.loading = true;
			this.facturadorService
				.getFile(dte.importacionMasivaId)
				.subscribe(
					(res) => {
						let uint8Array = res.data as Uint8Array;
						let b64Response = res.data;
						//obtained  8bit array from response that need to be transformed into a Blob
						try {
							const blobCsv = this.utilities.convertB64ToBlob(b64Response, "text/csv");
							FileSaver.saveAs(blobCsv, "lista_de_facturas.csv");
						} catch (error) {
							this.setSwalAndFire(this.currentSwal, "error", "Error en Archivo", "No fue posible obtener el archivo CSV, favor contactar al administrador\n" + error);
						}
					},
					(error) => {
						this.setSwalAndFire(this.currentSwal, "error", "Error", "Error al obtener el archivo. Intente más tarde." + this.utilities.setErrorMessageFromArray(error.error));
					}
				)
				.add(() => {
					this.loading = false;
					this.ref.detectChanges();
				});
		} else {
			Swal.fire({
				icon: "error",
				title: "Error al Obtener archivo",
				text: "El documento seleccionado no posee un archivo de importación masiva",
			});
		}
	}
	getEmisoresFullList() {
		this.emisorService.getData().subscribe(
			(result) => {
				let emisores = result.data;
				this.empresasSource = emisores;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en emisores",
					text: "No fue posible obtener la lista de emisores completa, tiene disponible solamente los emisores ya presentes en el selector de empresas." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	

	openExportModal() {
		const modalRef = this.modalService.open(ExportModalComponent, {
		  size: 'md',
		  centered: true
		});
	    modalRef.componentInstance.locale = this.locale;	  
		modalRef.componentInstance.filter = { ...this.filter };
		modalRef.componentInstance.type = 110;
		modalRef.componentInstance.totalItems = 15000;					
		modalRef.componentInstance.getPagedDataFunction = this.getDataToExport.bind(this);
		modalRef.componentInstance.exportData.subscribe((loadingStatus) => {
		  this.loading = loadingStatus;
		  this.ref.detectChanges();
		});
	  }

	//   getDataToExport(filter: FacturaExportacionFilter, page: Page): Observable<PagedResponse<FacturaExportacion>> {
	// 	return this.dteService.getDataByPage(filter, page);
	//   }	 

	  getDataToExport(filter: FacturaExportacionFilter, totalEments: number): Observable<PagedResponse<FacturaExportacion>> {
		let fullPage: Page = new Page();
		fullPage.pageSize = totalEments;
		fullPage.pageNumber = 0;
		fullPage.totalElements = totalEments;
		fullPage.totalPages = 1;
		this.loading = true;
		this.loading = true;
		return this.dteService.getDataByPage(filter, fullPage);
	  }	 


	  	//EXCEL EXPORT METHODS
	//Los metodos son DERCARGAR TODO, DESCARGAR LO FILTRADO(filtro aplicado en una sola hoja), DESCARGAR SELECCION
	// exportToExcel(dates: { fechaDesde: moment.Moment; fechaHasta: moment.Moment }) {
	// 	if (dates && dates.fechaDesde && dates.fechaHasta) {
	// 	  this.loading = true;
	// 	  //this.filter.fechaDesde = dates.fechaDesde.format('YYYY-MM-DD');
	// 	  //this.filter.fechaHasta = dates.fechaHasta.format('YYYY-MM-DD');
	// 	  this.getAllRowsByFilter(this.page, this.filter);
	// 	}
	//   }

	// getAllRowsByFilter(currentPageRef: Page, currentFilter: FacturaExportacionFilter) {
	// 	let fullPage: Page = new Page();
	// 	fullPage.pageSize = currentPageRef.totalElements;
	// 	fullPage.pageNumber = 0;
	// 	fullPage.totalElements = currentPageRef.totalElements;
	// 	fullPage.totalPages = 1;
	// 	this.loading = true;
	// 	this.dteService.getDataByPage(currentFilter, fullPage).subscribe(
	// 		(result) => {
	// 			let elements = result.data as FacturaExportacion[];
	// 			elements.forEach((row) => {
	// 				this.setEmisorToElement(row);
	// 				this.setTipoDteToElement(row);
	// 			});
	// 			this.loading = false;
	// 			this.ref.detectChanges();
	// 			this.exportExcelData(elements);
	// 		},
	// 		(error) => {
	// 			this.loading = false;
	// 			this.ref.detectChanges();
	// 			this.currentSwal.icon = "error";
	// 			this.currentSwal.title = "Error al exportar";
	// 			this.currentSwal.text = "No es posible exportar los datos. Intente mas tarde. ";
	// 			this.currentSwal.text += this.utilities.setErrorMessageFromArray(error.error);
	// 		},
	// 		() => {
	// 			this.loading = false;
	// 			this.ref.detectChanges();
	// 		}
	// 	);
	// }

	
}
